import React, { FC } from 'react';
import Styles from '@/assets/js/Styles';
import Container from '@/components/Container';
import { Typography } from '@mui/material';
import { ChildrenProp } from '@/declarations/ChildrenProp';

interface TotalCountWidgetProps {
  title?: string;
  description?: string;
}

export const TotalCountWidget: FC<ChildrenProp & TotalCountWidgetProps> = ({ children, title, description }) => {
  return (
    <Container
      column
      fullWidth
      fullHeight
      sx={{
        p: 4,
        background: `${Styles.Colors.WHITE}`,
        borderRadius: Styles.Dimensions.RADIUS_ROUNDNESS_DEFAULT,
        boxShadow: '1px 2px #ccc',
      }}>
      <Container fullWidth>
        <Typography sx={{ fontSize: '1.25rem', fontWeight: 500 }}>{title}</Typography>
      </Container>
      {description}
      {children}
    </Container>
  );
};
